import { render, staticRenderFns } from "./RestoreTemplate.vue?vue&type=template&id=68dfc09c&scoped=true&"
import script from "./RestoreTemplate.vue?vue&type=script&lang=js&"
export * from "./RestoreTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RestoreTemplate.vue?vue&type=style&index=0&id=68dfc09c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dfc09c",
  null
  
)

export default component.exports